import { Button } from "@mui/material";

// Fotoğraflar public/assets/images/oyun2026/ klasöründe
const IMG = "/assets/images/oyun2026/";

const pairStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(min(320px, 100%), 1fr))",
  gap: 14,
  maxWidth: 1000,
  margin: "10px auto",
};

const photoStyle = { width: "100%", borderRadius: 6, display: "block" };

export default function Year2026() {
  return (
    <div className="history2021">
      <div>
        <h1>Türkiye 31. Zeka Oyunları Yarışması</h1>
        <h2>
          <strong>OYUN 2026'nın Sonuçları Açıklandı!</strong>
        </h2>
      </div>

      <div>
        <img
          style={{ maxWidth: 1000, width: "100%" }}
          src={IMG + "toplu.jpg"}
          alt="OYUN 2026 ödül töreni toplu fotoğrafı"
        />
        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Türkiye 31. Zeka Oyunları Yarışması “OYUN 2026” final sınavı ODTÜ’de
          gerçekleşti.
        </h3>
        <p style={{ textAlign: "left" }}>
          10 Ekim 2026 tarihinde, Türkiye Zeka Vakfı tarafından Yamantürk
          Vakfı’nın desteğiyle düzenlenen 31. Türkiye Zeka Oyunları Yarışması,
          ODTÜ Eğitim Fakültesi’nde yapılan final sınavı ve ödül töreniyle sona
          erdi. Türkiye’nin dört bir yanından gelen 500 finalist sınava katıldı.
        </p>
        <p style={{ textAlign: "left" }}>
          Sözel, sayısal, görsel ve mantık alanlarında hazırlanan özgün
          sorulardan oluşan final sınavı; “Minikler”, “Çocuklar”, “Gençler”,
          “Yetişkinler” ve “Emektarlar” kategorilerinde yapıldı. Her yaş
          grubundan katılımcı, sınav süresince farklı düşünme becerilerini
          sınama fırsatı buldu.
        </p>
        <p style={{ textAlign: "left" }}>
          Final sınavı, sabah saat 11.00’de tüm kategoriler için başladı ve
          12.00’de sona erdi. Sınavın ardından yarışmacıların sınav kağıtları
          değerlendirilerek kazananlar belirlendi. Saat 16.00’da ODTÜ Eğitim
          Fakültesi Çok Amaçlı Konferans Salonu’nda gerçekleştirilen ödül
          töreniyle dereceye giren yarışmacılar başarılarını taçlandırdı.
        </p>

        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>Ödül Töreni</h3>
        <p style={{ textAlign: "left" }}>
          Ödül töreninde konuşan Türkiye Zeka Vakfı Başkanı Emrehan Halıcı,
          bilgiye ulaşmanın her geçen gün kolaylaştığı günümüzde asıl önemli
          olanın, ulaşılan bilgiyi doğru değerlendirebilmek ve doğru
          kullanabilmek olduğunu vurguladı. Dereceye giren finalistlere
          madalyaları Emrehan Halıcı tarafından takdim edildi; tüm finalistler
          tebrik edildi, başarıları alkışlandı.
        </p>

        <div style={pairStyle}>
          <img
            style={photoStyle}
            src={IMG + "minikler.jpg"}
            alt="Minikler kategorisi dereceye girenler"
          />
          <img
            style={photoStyle}
            src={IMG + "cocuklar.jpg"}
            alt="Çocuklar kategorisi dereceye girenler"
          />
          <img
            style={photoStyle}
            src={IMG + "gencler.jpg"}
            alt="Gençler kategorisi dereceye girenler"
          />
          <img
            style={photoStyle}
            src={IMG + "yetiskinler.jpg"}
            alt="Yetişkinler kategorisi dereceye girenler"
          />
          <img
            style={photoStyle}
            src={IMG + "emektarlar.jpg"}
            alt="Emektarlar kategorisi dereceye girenler"
          />
          <img
            style={photoStyle}
            src={IMG + "odul-toreni-1.jpg"}
            alt="Ödül töreninden bir kare"
          />
        </div>

        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Şeref Kürsüsünde Başarı Öyküleri
        </h3>
        <p style={{ textAlign: "left" }}>
          Her kategoride dereceye giren yarışmacılar “Şeref Kürsüsü” sayfasında
          yer alacaktır. Final sınavı sonuçlarınıza ve Şeref Kürsüsü’ne profil
          sayfanızdan ulaşabilirsiniz.
        </p>
      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <Button
          color="secondary"
          style={{
            marginLeft: 3,
            marginRight: 3,
            marginBottom: 6,
          }}
          variant="contained"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://oyun.tzv.org.tr/hall_of_fame"
            style={{ color: "white", textDecoration: "none" }}
          >
            Dereceye Giren Yarışmacılar
          </a>
        </Button>
      </div>
    </div>
  );
}
